export enum PhoneNumberStatus {
    ACTIVE = "active",
    INACTIVE = "inactive",
}

export type IPhoneNumber = {
    id: string;
    number: string;
    isActive: boolean;
    name?: string;
    countries?: string[];
    brands?: string[];
    priority?: number;
};

// phone number type from backend
export type ApiPhoneNumber = {
    id?: string;
    phoneNumber: string;
    status: PhoneNumberStatus;
    name?: string;
    countries?: string[];
    brands?: string[];
    type?: "active" | "verified";
    friendlyName?: string;
    createdAt?: string;
    updatedAt?: string;
    priority?: number;
};

// phone number type from twilio
export type AvailablePhoneNumber = {
    phoneNumber: string;
    friendlyName: string;
    status: string;
    type: string;
};

// phone number type for creating
export type CreatePhoneNumberPayload = {
    phoneNumber: string;
    name?: string;
    countries?: string[];
    brands?: string[];
    status?: PhoneNumberStatus;
};
